// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"01ce153f","875":"5ac605aa"}[chunkId] + ".chunk.js";
};